<div class="bg-th-yellow mt-0 container-fluid py-2">
  <div class="d-flex justify-content-between align-content-center">
    <i
      class="fa fa-arrow-left text-secondary my-auto pointer text-dark"
      [routerLink]="['/']"
    ></i>

    <a class="d-flex align-items-center text-secondary f18 my-auto text-dark">
      <span class="fw-bold"> مدیریت مشتریان آب شرب </span>
    </a>
  </div>
</div>

<main class="px-2">
  <!-- جدول اطلاعات -->
  <div class="border border-2 container-fluid row gx-0 gy-2 mt-3 p-2">
    <!-- جستجو -->

    <div class="col-8 p-1">
      <input
        type="text"
        class="w-100 form-control"
        placeholder="جستجو کنید ..."
        (input)="filterResult($event.target.value)"
      />
    </div>

    <!-- افزودن -->

    <div class="col-auto p-1">
      <button
        class="w-100 h-100 btn btn-success"
        (click)="openAddOrUpdateUserModal()"
      >
        &nbsp; افزودن &nbsp;
      </button>
    </div>

    <!-- نقشه -->

    <div class="col-auto p-1">
      <button
        class="w-100 h-100 btn btn-outline-secondary"
        (click)="showOnMap()"
      >
        &nbsp; نقشه &nbsp;
      </button>
    </div>

    <!-- خروجی اکسل -->

    <div class="col-auto p-1">
      <button
        class="w-100 h-100 btn btn-outline-secondary"
        (click)="exportExcel()"
      >
        &nbsp; خروجی اکسل &nbsp;
      </button>
    </div>

    <!-- جدول اطلاعات -->

    <div class="section border border-2 mt-2">
      <table class="col-12 table table-striped rounded-3" id="Export_Excel">
        <thead>
          <tr class="text-center">
            <th scope="col" class="">#</th>

            <th scope="col" class="">عملیات</th>

            <th scope="col" class="">نام</th>

            <th scope="col" class="">کاربری</th>

            <th scope="col" class="">تاریخ شروع</th>

            <th scope="col" class="">تاریخ پایان</th>

            <th scope="col" class="">سقف تحویل(لیتر)</th>
          </tr>
        </thead>

        <tbody>
          <tr
            class="f14 text-center"
            *ngFor="let item of lst_Clients; let i = index"
          >
            <th class="text-dark">{{ i + 1 | faNum }}</th>

            <th class="">
              <i
                class="fa fa-edit fa-lg text-primary pointer"
                title=" ویرایش"
                (click)="openAddOrUpdateUserModal(item, i)"
              ></i>

              <i
                class="fa fa-trash mx-2 fa-lg text-danger pointer"
                title="حذف"
                (click)="removeClient(item, i)"
              ></i>

              <i
                class="fa fa-calendar fa-lg text-dark pointer"
                title="برنامه تحویل"
                (click)="openDeliveryScheduleModal(item, i)"
              ></i>
            </th>

            <td>{{ item.strName | faNum }}</td>

            <td>{{ item.strTanker_WaterClientUsage_strComment ?? "" }}</td>

            <td>{{ item.strSDate | faNum }}</td>

            <td>{{ item.strEDate | faNum }}</td>

            <td>{{ item.iDeliveryLimit.toLocaleString() | faNum }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- add or update user modal -->
  <div
    class="modal fade"
    id="addOrUpdateUser_Modal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content dirI">
        <div class="modal-header dirI">
          <h5 class="modal-title" id="exampleModalLabel">مشخصات مشتری</h5>

          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div
            [formGroup]="addUserForm"
            class="container-fluid row gx-2 gy-2 p-2"
          >
            <!-- نام -->

            <div class="position-relative col-12 col-md-4 p-2">
              <label class="mb-2 text-muted"> نام </label>

              <input
                class="form-control p-2 text-center"
                formControlName="strName"
              />
            </div>

            <!-- کاربری -->

            <div class="position-relative col-12 col-md-4 p-2">
              <label class="mb-2 text-muted"> کاربری </label>

              <select
                class="form-select p-2"
                formControlName="tiTanker_WaterClientUsage"
              >
                <option class="text-center" value="">انتخاب کنید</option>

                <option
                  class="text-center"
                  *ngFor="let item of lst_ClientUsage"
                  [value]="item.tiTanker_WaterClientUsage"
                >
                  {{ item.strComment }}
                </option>
              </select>
            </div>

            <!-- شماره قرارداد -->

            <div class="position-relative col-12 col-md-4 p-2">
              <label class="mb-2 text-muted"> شماره قرارداد </label>

              <input
                class="form-control p-2 text-end"
                oninput="
                  this.value = this.value.replace(/[^0-9]/g, '').toString()
                "
                formControlName="strContractNumber"
              />
            </div>

            <!-- تاریخ شروع -->

            <div class="position-relative col-12 col-md-4 p-2">
              <label> تاریخ شروع </label>

              <ng-persian-datepicker
                [uiTheme]="'gray'"
                [timeEnable]="false"
                [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true"
                [dateFormat]="'jYYYY/jMM/jDD'"
              >
                <input
                  formControlName="strSDate"
                  class="form-control text-end"
                />
              </ng-persian-datepicker>
            </div>

            <!-- تاریخ پایان -->

            <div class="position-relative col-12 col-md-4 p-2">
              <label> تاریخ پایان </label>

              <ng-persian-datepicker
                [uiTheme]="'gray'"
                [timeEnable]="false"
                [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true"
                [dateFormat]="'jYYYY/jMM/jDD'"
              >
                <input
                  formControlName="strEDate"
                  class="form-control text-end"
                />
              </ng-persian-datepicker>
            </div>

            <!-- سقف تحویل ماهیانه(L) -->

            <div class="position-relative col-12 col-md-4 p-2">
              <label class="mb-2 text-muted"> سقف تحویل ماهیانه(L) </label>

              <input
                class="form-control p-2 text-center"
                oninput="
                  this.value = this.value
                    .replace(/[^0-9]/g, '')
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                formControlName="iDeliveryLimit"
              />
            </div>

            <!-- تلفن -->

            <div class="position-relative col-12 col-md-4 p-2">
              <label class="mb-2 text-muted"> تلفن </label>

              <input
                class="form-control p-2 text-end"
                oninput="
                  this.value = this.value.replace(/[^0-9]/g, '').toString()
                "
                maxlength="11"
                formControlName="strTel"
              />
            </div>

            <!-- آدرس -->

            <div class="position-relative col-12 col-md-8 p-2">
              <label class="mb-2 text-muted"> آدرس </label>

              <input
                class="form-control p-2 text-start"
                formControlName="strAddress"
              />
            </div>

            <!-- نقشه -->

            <div class="position-relative col-12 p-2">
              <div id="clientsMap">
                <div
                  class="position-absolute"
                  id="map_tooltip"
                  data-bs-html="true"
                ></div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer d-flex justify-content-start">
          <button class="btn btn-primary" (click)="submitUser()">
            ذخیره اطلاعات
          </button>

          <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
            &nbsp; بستن &nbsp;
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- tanker Delivery Schedule Modal -->
  <div class="modal fade" id="tankerDeliveryScheduleModal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content dirI">
        <div class="modal-header dirI">
          <h5 class="modal-title" id="exampleModalLabel">برنامه تحویل</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div class="container-fluid row gx-0 gy-2 p-2">
            <div class="col-12">
              <input class="w-100 form-control" placeholder="جستجو کنید ..." />
            </div>

            <!-- جدول اطلاعات -->
            <div class="border mt-2">
              <table class="col-12 table table-striped rounded-3">
                <thead>
                  <tr class="text-center">
                    <th scope="col">#</th>
                    <th scope="col">
                      <input class="form-check-input mx-1" type="checkbox" [checked]="selectAll" (change)="toggleAll($event.target.checked)"/>
                    </th>
                    <th scope="col">مشتری</th>
                    <th scope="col">تاریخ و ساعت</th>
                    <th scope="col">روز</th>
                    <th scope="col">تانکر</th>
                    <th scope="col">مقدار</th>
                    <th scope="col">توضیحات</th>
                    <th scope="col">تحویل شده</th>
                    <th scope="col">زمان تحویل</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="text-center" *ngFor="let item of deliveryScheduleList; let i = index">
                    <th class="text-dark">{{ i + 1 | faNum }}</th>
                    <td><input class="form-check-input" type="checkbox" [checked]="isSelected(item)" (change)="setCheckBox($event.target.checked,item)"/></td>
                    <td>{{ item.strName }}</td>
                    <td>{{ item.strRequestedDeliveryTime | faNum }}</td>
                    <td>{{ item.strDayName }}</td>
                    <td>{{ item.strTankerName }}</td>
                    <td>{{ item.iValue | faNum }}</td>
                    <td>{{ item.strComment }}</td>
                    <td>
                      <i
                        *ngIf="item.bDelivered"
                        class="fa fa-check text-success"
                      ></i>
                      <i
                        *ngIf="!item.bDelivered"
                        class="fa fa-times text-danger"
                      ></i>
                    </td>
                    <td>
                      {{
                        item.strDeliveredTime
                          ? (item.strDeliveredTime | faNum)
                          : "-"
                      }}
                    </td>
                  </tr>
                  <tr
                    *ngIf="
                      !deliveryScheduleList || deliveryScheduleList.length === 0
                    "
                  >
                    <td colspan="10" class="text-center text-muted py-3">
                      رکوردی برای نمایش وجود ندارد.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="modal-footer d-flex justify-content-start">
          <button class="btn btn-primary" (click)="showSchedulePlanner()">
            برنامه‌ریزی
          </button>
          <button class="btn btn-info" (click)="openDefineTankerModal()">تعیین تانکر</button>
          <button class="btn btn-outline-danger" (click)="removeSchedule()">حذف</button>
          <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
            &nbsp; بستن &nbsp;
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- tanker Delivery Schedule Modal -->
  <div class="modal fade" id="schedulePlannerModal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content dirI">
        <div class="modal-header dirI">
          <h5 class="modal-title" id="exampleModalLabel">برنامه ریزی</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div
            [formGroup]="deliveryScheduleForm"
            class="container-fluid row gx-2 gy-2 p-2"
          >
            <!-- از تاریخ -->
            <div class="position-relative col-12 col-md-4 p-2">
              <label class="mb-2 text-muted"> از تاریخ </label>
              <ng-persian-datepicker
                [uiTheme]="'gray'"
                [timeEnable]="false"
                [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true"
                [dateFormat]="'jYYYY/jMM/jDD'"
              >
                <input
                  formControlName="strSDate"
                  readonly
                  class="form-control text-end"
                />
              </ng-persian-datepicker>
            </div>

            <!-- تا تاریخ -->
            <div class="position-relative col-12 col-md-4 p-2">
              <label class="mb-2 text-muted"> تا تاریخ </label>
              <ng-persian-datepicker
                [uiTheme]="'gray'"
                [timeEnable]="false"
                [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true"
                [dateFormat]="'jYYYY/jMM/jDD'"
              >
                <input
                  formControlName="strEDate"
                  readonly
                  class="form-control text-end"
                />
              </ng-persian-datepicker>
            </div>

            <!-- کامبو روز -->
            <div class="position-relative col-12 col-md-4 p-2">
              <label class="mb-2 text-muted"> روز </label>
              <select class="form-select p-2" formControlName="strDayName">
                <option class="text-center" value="">انتخاب کنید</option>
                <option
                  class="text-center"
                  *ngFor="let day of daysOfWeek"
                  [value]="day"
                >
                  {{ day }}
                </option>
              </select>
            </div>

            <!-- ساعت -->
            <div class="position-relative col-12 col-md-4 p-2">
              <label class="mb-2 text-muted" style="z-index: 10"> ساعت </label>
              <div class="input-group clockpicker">
                <input
                  readonly
                  class="form-control p-2 text-center"
                  id="deliveryTime"
                  formControlName="strTime"
                />
                <span class="input-group-addon">
                  <span class="glyphicon glyphicon-time"></span>
                </span>
              </div>
            </div>

            <!-- مقدار -->
            <div class="position-relative col-12 col-md-4 p-2">
              <label class="mb-2 text-muted"> مقدار </label>
              <input
                class="form-control p-2 text-center"
                oninput="
                  this.value = this.value
                    .replace(/[^0-9]/g, '')
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                formControlName="iValue"
              />
            </div>

            <!-- توضیحات -->
            <div class="position-relative col-12 p-2">
              <label class="mb-2 text-muted"> توضیحات </label>
              <textarea
                style="height: 100px; resize: none"
                class="form-control"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="modal-footer d-flex justify-content-start">
          <button class="btn btn-success" (click)="submitSchedulePlan()">
            ذخیره
          </button>
          <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
            &nbsp; بستن &nbsp;
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Define tanker Modal -->
  <div class="modal fade" id="defineTankerModal">
    <div class="modal-dialog">
      <div class="modal-content dirI">
        <div class="modal-header dirI">
          <h5 class="modal-title" id="exampleModalLabel">تعیین تانکر</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div [formGroup]="assignTankerForm" class="container-fluid row gx-2 gy-2 p-2">
            <div class="position-relative col-12 p-2">
              <label class="mb-2 text-muted"> تانکر </label>
              <select class="form-select p-2" formControlName="strUnitID">
                <option class="text-center" value="">انتخاب کنید</option>
                <option class="text-center" *ngFor="let item of tankerList" [value]="item.strUnitID">
                  {{ item.strFullName }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="modal-footer d-flex justify-content-start">
          <button class="btn btn-success" (click)="submitAssignTanker()">
            تایید
          </button>
          <button class="btn btn-outline-secondary" data-bs-dismiss="modal">
            &nbsp; بستن &nbsp;
          </button>
        </div>
      </div>
    </div>
  </div>
</main>
